<template lang="pug">
    div.customer-area.pa-5
        //- v-toolbar(card :color="colors.primary" dark)
        //-     v-toolbar-title Registro Cliente
        //-     v-spacer
        //-     //- v-btn(icon)
        //-     //-     v-icon apps
            
        //-     v-btn(icon to="/cash_desk")
        //-         v-icon() arrow_back
        v-card.pa-4.d-flex.align-center
            v-form(ref="form"  lazy-validation)    
                v-layout(row wrap)
                    v-flex.xs12
                        rut-input.mx-3(
                            ref="rut" 
                            v-model="rut" 
                            @input="updateStateOnInput()" 
                            )
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="30"  
                            label="Nombre/Nombre de Fantasía" 
                            :rules="rules.personName" 
                            v-model="personName" 
                            @input="updateStateOnInput()" 
                            ref="person_name"
                            )
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="30"  
                            label="Razón Social" 
                            :rules="rules.businessName" 
                            v-model="businessName" 
                            @input="updateStateOnInput()"
                            )
                    //- v-flex.xs12.md6
                    //-     v-text-field.mx-3(
                    //-         maxlength="30"  
                    //-         label="Giro" 
                    //-         :rules="rules.coreBusiness" 
                    //-         v-model="coreBusiness" 
                    //-         @input="updateStateOnInput()"
                    //-         ) 
                    v-flex.xs12.md6
                        v-autocomplete.mx-3(
                            label="Giros" 
                            :rules="rules.coreBusiness" 
                            v-model="CoreBusinessSelected" 
                            :items="multipleCoreBusiness"
                            item-value="id"
                            item-text="core_business"
                            @input="updateStateOnInput()"
                            chips
                            deletable-chips
                            multiple
                            ) 
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="80"  
                            label="Dirección" 
                            :rules="rules.address" 
                            v-model="address" 
                            @input="updateStateOnInput()"
                            ) 
                    
                    v-autocomplete.mx-3(
                        v-model="selectedCommune" 
                        item-text="name" 
                        item-value="id" 
                        :items="communes" 
                        label="Comuna" 
                        :rules="[mixRules.required]" 
                        @change="updateStateOnInput()"
                        )
                    v-flex.xs6
                        v-autocomplete.mx-3(
                            v-model="selectedCity" 
                            item-text="name" 
                            item-value="id" 
                            :items="cities" 
                            label="Ciudad" 
                            :rules="[mixRules.required]" 
                            @change="updateStateOnInput()"
                            )
                    v-flex.xs6
                        v-text-field.mx-3(
                            maxlength="50"
                            v-model="zone"
                            label="Sector"
                            @input="updateStateOnInput()"
                            )
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="15"  
                            label="Teléfono" 
                            :rules="rules.phone" 
                            v-model="phone" 
                            @input="updateStateOnInput()"
                            mask="#########"
                            prefix="+56"
                            ) 
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="15" 
                            v-model="phone2" 
                            label="Teléfono 2" 
                            :rules="rules.phone" 
                            @input="updateStateOnInput()"
                            mask="#########"
                            prefix="+56"
                            ) 
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="50"  
                            label="Email" 
                            :rules="rules.email" 
                            v-model="email" 
                            @input="updateStateOnInput()"
                            )
                    
                    v-flex.xs12.md6(align-self-end)
                        v-btn(round larg @click="clickSubmitNewCustomer") Registrar
</template>

<script>
import RUTInput from '@/components/RUTInput/RUTInput'
import InputValidations from '@/mixins/InputValidations'
import RutUtils from '@/mixins/RUTUtils'
import {  mapActions, mapState } from 'vuex'
import {  addRUTHyphen } from '@/services/RUTFormatter'
import GirosMdl  from '@/models/General/GCoreBusinessSii'
export default {
    name: 'customer-form',
    props: {},
    data: function() {
        return {
            rut: '',
            businessName: '',
            personName: '',
            coreBusiness: '',
            address: '',
            state: '',
            phone: '',
            email: '',
            editable: false,
            test: null,
            showMessage: false,
            selectedCommune:'',
            selectedCity:'',
            zone:'',
            multipleCoreBusiness:[],
            CoreBusinessSelected:null,
            idCustomer:null,
        }
    },
    computed: {
        ...mapState('SessionModule', {
            communes: 'communes',
            cities: 'cities',
        }),
        // ...mapState('CustomerModule', {
        //     customerData: 'customerData',
        //     createMode: 'createMode'
        // }),
        // /**
        //  * @description
        //  */
        ...mapState('CustomerModule',{
            customerData : 'customerData'
        }),
        rules: function() {
            let rules = []

            rules = {
                personName: [this.mixRules.required],
                businessName: [this.mixRules.required],
                coreBusiness: [this.mixRules.required],
                address: [this.mixRules.required],
                state: [this.mixRules.required],
                phone: [],
                email: [this.mixRules.required, this.mixRules.email],
            }
            return rules
        },
        customer: function() {
            return {
                //id:this.idCustomer,
                rut: addRUTHyphen(this.rut),
                business_name: this.businessName,
                alias_name: this.personName,
                core_business: this.CoreBusinessSelected,
                email_collection: this.email,
                branch_offices:[{
                    address: this.address,
                    phone: this.phone || null,
                    phone2: this.phone2 || null,
                    email: this.email,
                    g_commune_id: this.selectedCommune,
                    default_branch_office: true,
                    city: this.selectedCity || null,
                    zone: this.zone || null,
                }],
                blocked_sales:false,
                
            }
        },


    },
    methods: {
        async clickSubmitNewCustomer() {
            if (this.$refs.form.validate()) {
                let response = await this.submitNewCustomer(this.customer)
                console.log(response.status,'status')
                if ((response.status == 'success')) {
                    //display snackbar and return to caja
                    let payload = {
                        typeMessage: 'success',
                        message: {
                            title: 'Nuevo CLiente',
                            body: 'Cliente registrado exitosamente',
                        },
                        timeout: 5000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.customer.id = response.customer_id
                    this.setCustomerData(this.customer)
                    
                    this.initSnackbar(payload)
                    this.$emit('createCustomer',this.customer)
                    this.$router.push('/')

                } 
                if ((response.status == 'error')) {

                    let payload = {
                        typeMessage: 'warning',
                        message: {
                            title: 'Error',
                            body: response.errors.rut,
                        },
                        timeout: 5000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)
                }
            } else {
                alert('no validado')
            }
        },
        handleCustomerSearch(e) {
            console.log('handleCustomerSearch',e)
            console.log(e.rut)
            this.idCustomer = e.id
            //this.onValidRut(true, e.rut)
            this.rut = addRUTHyphen(e.rut)
            
        },
        ...mapActions('CustomerModule', {
            setCustomerData: 'setCustomerData',
            fetchCustomerData: 'fetchCustomerData',
            submitNewCustomer: 'submitNewCustomer',
            setCoreBusinessCustomer:'setCoreBusinessCustomer',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        updateStateOnInput() {
            
            this.setCustomerData(this.customer)
        },
        async fetchAllGiros() {
            let response = await GirosMdl.limit(-1).get()
            this.multipleCoreBusiness = response.data
            console.log(response,'FETCHaLLGIROS')
        },
        
        // initData: function() {
        //     this.rut = this.customerData.rut
        //     this.businessName = this.customerData.businessName
        //     this.personName = this.customerData.personName
        //     this.coreBusiness = this.customerData.coreBusiness
        //     this.address = this.customerData.address
        //     this.phone = this.customerData.phone
        //     this.email = this.customerData.email
        // },
        // onValidRut: async function(event) {
        //     if (!event) {
        //         this.editable = false
        //         return
        //     }
        //     if (this.rut.length <= 7) return
        //     const response = await this.fetchCustomerData(
        //         { field: 'rut', value: this.rut },
        //     )
        //     response.then(customer => {
        //         if (customer) {
        //             this.editable = false
        //             this.initData()
        //             this.toggleCreateMode(false)
        //         } else {
        //             this.editable = true
        //             this.toggleCreateMode(true)
        //         }
        //     })
        // },
        ...mapActions('SessionModule', {
            initCommunes: 'initCommunes',
        }),
    },
    watch: {},
    components: { 'rut-input': RUTInput, },
    mixins: [InputValidations, RutUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        //alert(this.customerData.rut)
        this.rut = this.customerData.rut
        this.$nextTick(() =>  this.$refs.person_name.focus())
       this.initCommunes()
       this.fetchAllGiros()
    },
    // beforeMount: function(){...},
    // mounted: function() {
    //     this.$refs.rut.$refs.rut.focus()
    // },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.customer-area {
    height: calc(100% - 9px);
    .customer-card {
        height: 100%;
        .notification-span {
            position: fixed;
            width: 100%;
            margin-left: -3em;
            margin-top: -17em;
        }
    }
}
</style>